import { useState } from 'react'
import { useStatusOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import useErrorReporter from './useErrorReporter'

export default function useResendEmail(resendFn) {
  const { t } = useTranslation()
  const reportError = useErrorReporter()
  const showStatusOverlay = useStatusOverlay()
  const [loading, setLoading] = useState(false)

  const resend = async () => {
    try {
      setLoading(true)
      await resendFn()
      showStatusOverlay({
        message: t('email-resent.feedback', 'A verification email was successfully resent.'),
        type: 'success',
      })
    } catch (error) {
      reportError(error)
    } finally {
      setLoading(false)
    }
  }

  return { resend, resending: loading }
}
